// extracted by css-extract-rspack-plugin
export default {"spaceFluid":"100%","size500":"500px","wrapper":"DatePicker-module__wrapper___Isb8s","datePickerWrapper":"DatePicker-module__datePickerWrapper___IQrZK"};